// extracted by mini-css-extract-plugin
export default {"badge":"gVdxG","gray":"sKya8","teal":"fvWuN","skeleton-placeholder-pulse":"VLeHa","skeletonPlaceholderPulse":"VLeHa"};